import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ScoreResultsPage } from './components/ScoreResultsPage';
import './index.css';
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}
const isScorePage = window.location.pathname.replace(/\/+$/, '') === '/score';
createRoot(rootElement).render(isScorePage ? <ScoreResultsPage search={window.location.search} data-id="element-528" /> : <App data-id="element-529" />);